<template>
  <v-card>
    <v-card-title>Harmonogram wizyt - cyklicznych</v-card-title>
    <v-card-text>
      <v-simple-table fixed-header height="600px">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Data wizyty</th>
              <th class="text-left">Wyklucz wizytę</th>
              <th class="text-left">Akcje</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in processedDates" :key="item.date">
              <td :class="{ 'red--text': item.isException }">
                <v-tooltip bottom v-if="item.isException">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ formatDate(item.date) }}
                      <v-icon small>fas fa-info-circle</v-icon>
                    </span>
                  </template>
                  <span>{{ item.exceptionReason }}</span>
                </v-tooltip>
                <span v-else>{{ formatDate(item.changedDate || item.date) }}</span>
              </td>
              <td>
                <v-checkbox v-model="item.excluded"></v-checkbox>
              </td>
              <td>
                <v-tooltip bottom v-if="item.isException">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="handleActionClick(item)" v-bind="attrs" v-on="on">
                      <v-icon color="green">fas fa-bolt</v-icon>
                    </v-btn>
                  </template>
                  <span>Zmień datę</span>
                </v-tooltip>
                <v-icon v-else-if="item.changedDate" color="green">fas fa-check</v-icon>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handleOk">OK</v-btn>
    </v-card-actions>
    <v-dialog v-model="showTherapistsVisitsSchedulesDialog" transition="dialog-bottom-transition" persistent max-width="700px">
      <v-card flat>
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="showTherapistsVisitsSchedulesDialog = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Dostepne terminy</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <TherapistsVisitsSchedules v-if="showTherapistsVisitsSchedulesDialog" :therapistid="therapistId" :startDate="selectedDate" :typWizytyId="typWizytyId" @datepicked="onDatePickedTherapistShechedules"></TherapistsVisitsSchedules>
        </v-card-text>
      </v-card>
    </v-dialog>    
  </v-card>
</template>

<script>
import * as dayjs from "dayjs";
import TherapistsVisitsSchedules from "./TherapistsVisitsSchedules.vue";

export default {
  name: "RegularVisitDates",
  components: {
    TherapistsVisitsSchedules,
  },
  props: {
    visitData: {
      type: Object,
      required: true,
      default: () => ({
        visitDates: [],
        visitDatesWithException: []
      })
    },
    typWizytyId: {
      type: Number,
      required: false,
    },
    therapistId: {
      type: Number,
      required: true,
    },
    currentDatesStatuses: {
      type: Object,
      required: false      
    }
  },
  data() {
    return {
      processedDates: [],
      showTherapistsVisitsSchedulesDialog: false,
      selectedDate: null,
      therapists_visits_schedules: false,
    };
  },
  watch: {
    visitData: {
      handler() {
        this.initializeDates();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    initializeDates() {
      const regularDates = this.visitData.visitDates || [];
      const exceptionDatesWithOptions = this.visitData.visitDatesWithException || [];
      const exceptionDateStrings = exceptionDatesWithOptions.map(e => e.visitDate);

      const allDateStrings = [...new Set([...exceptionDateStrings,...regularDates ])];

      this.processedDates = allDateStrings.map(date => {
        const exceptionInfo = exceptionDatesWithOptions.find(e => e.visitDate === date);
        return {
          date: date,
          isException: !!exceptionInfo,
          originalIsException: !!exceptionInfo,
          exceptionReason: exceptionInfo ? exceptionInfo.exceptionReason : null,
          excluded: false,
          changedDate: null,
        };
      });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      return dayjs(dateString).format('DD-MM-YYYY HH:mm');
    },
    handleOk() {

      //get unresolvedExceptions but only those which are not in excludedDates
      const excludedDates = this.processedDates.filter(item => item.excluded).map(item => item.date);
      const unresolvedExceptions = this.processedDates.filter(item => item.isException && !item.changedDate && !excludedDates.includes(item.date));


      if (unresolvedExceptions.length > 0) {
        // Don't emit save if there are unresolved exceptions
        this.$emit('close');
        return;
      }
      let result = {};
      if (this.currentDatesStatuses) {
        result = this.currentDatesStatuses;
        //insert excluded dates
        result.excludedDates = [ ...result.excludedDates ,...this.processedDates.filter(item => item.excluded).map(item => item.date)]
        result.resolvedExceptions = [ ...result.resolvedExceptions ,...this.processedDates.filter(item => item.originalIsException && item.changedDate)]
      }
      else {
        result = {
          excludedDates: this.processedDates.filter(item => item.excluded).map(item => item.date),
          resolvedExceptions: this.processedDates.filter(item => item.originalIsException && item.changedDate).map(item => ({
            originalDate: item.date,
            newDate: item.changedDate
          }))
        };  
      }
        
      console.log(result);      
      this.$emit('save', result);      
    },
    handleActionClick(item) {
      this.selectedDate = item.date;
      this.showTherapistsVisitsSchedulesDialog = true;
    },
    onDatePickedTherapistShechedules(date) {
      this.showTherapistsVisitsSchedulesDialog = false;
      const index = this.processedDates.findIndex(item => item.date === this.selectedDate);

      if (index !== -1) {
        const itemToUpdate = this.processedDates[index];

        const updatedItem = {
          ...itemToUpdate,
          isException: false,
          exceptionReason: null,
          changedDate: dayjs(date.StartTime).format(),
        };

        this.processedDates.splice(index, 1, updatedItem);
      }
    }
  }
};
</script>

<style scoped>
.red--text {
  color: red !important;
}
</style> 